<div class="main px-5">
  <div class="col-12 mt-3 py-2 px-5 bg-light-color">
    <div class="col-12 d-flex mt-3 justify-content">
      <div class="d-flex col-10">
        <p class="fw-bold text-primary-color mt-3">Movimentação Societária</p>
      </div>
    </div>

    <nz-divider class="m-0 p-0 my-2"></nz-divider>

    <div class="d-flex">
      <div class="col-12 px-0 py-3 border-gray box-shadow">
        <form [formGroup]="naturezaMudancaFilterForm" id="naturezaMudancaFilterForm" (ngSubmit)="save()">
          <div class="row row-cols-1 g-4 mb-2">
            <div class="col form-group">
              <label for="naturezaMudanca" class="form-label">Natureza da Mudança</label>
              <nz-select formControlName="naturezaMudanca" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large">
                <nz-option [nzValue]="item.id" [nzLabel]="item.descricao" *ngFor="let item of naturezaMudancaLista" />
              </nz-select>
            </div>
            <div class="col-sm-12 form-group d-flex justify-content-end mt-4 mb-3">
              <button nz-button type="button" nzType="default" nzSize="large"
                class="d-flex justify-content-center fw-semibold rounded-3 fs-6 me-2" (click)="voltar()">
                Voltar
              </button>
              <button nz-button type="submit" nzType="primary" nzSize="large"
                class="d-flex justify-content-center fw-semibold rounded-3 w-25 fs-6" form="naturezaMudancaFilterForm">
                Próximo
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
